import { useState, useEffect } from 'react';

function useLocalStorageState(key, defaultValue) {
  // Retrieve the stored value from localStorage, or use the default value
  const [state, setState] = useState(() => {
    try {
      const savedState = localStorage.getItem(key);
      return savedState !== null ? JSON.parse(savedState) : defaultValue;
    } catch (error) {
      console.error(`Error reading from localStorage:`, error);
      return defaultValue;
    }
  });

  // Save the state in localStorage whenever it changes
  useEffect(() => {
    try {
      localStorage.setItem(key, JSON.stringify(state));
    } catch (error) {
      console.error(`Error writing to localStorage:`, error);
    }
  }, [key, state]);

  return [state, setState];
}

export default useLocalStorageState;